import { Api } from "./Api";

export default new Api({
  baseUrl: process.env.GATSBY_API_BASE_URL
  // baseUrl: "http://localhost:8080"
});
